export const translate = (data) => {
	return _.language.GetTranslation(data);
};
